let cons = {
	// apis:'http://47.94.194.207:8002/meiduo_admin' // 远程地址


  //  大海老师测试接口
	// apis:'http://ttapi.research.itcast.cn/mis'
  apis: '//api-toutiao-web.itheima.net/mis'

  //  王老师测试接口
  // apis:'http://ttbk.grassroots001.cc/mis'
}

export default cons



// WEBPACK FOOTER //
// ./src/components/constant.js